import {assert} from 'Asserts';
import {NoteEditorPlugin} from 'notebook/notes/NoteEditorTypes';
import {findPlugin} from 'notebook/notes/plugins/NoteEditorPluginRegistry';
import getNotePartType from 'notebook/notes/util/getNotePartType';
import {NotePart} from 'notebook/util/NoteUtilConstants';

let pluginsRegistered = false;

function ensurePluginsRegistered(): void {
  if (!pluginsRegistered) {
    // NoteEditorPlugins must be imported asynchronously to avoid circular dependency at module load time
    // This will populate the plugin registry that is used by findPlugin below
    require('notebook/notes/plugins/NoteEditorPlugins');
    pluginsRegistered = true;
  }
}

export function getTablePlugin(notePart: NotePart): NoteEditorPlugin {
  ensurePluginsRegistered();
  const type = getNotePartType(notePart);
  assert(type != null, `Note part type not found for notePart id: ${notePart.id}`);
  const plugin = findPlugin(type);
  assert(
    plugin != null,
    `Plugin not found for type: ${type}. This should not happen after plugin registration.`
  );
  return plugin;
}
